import { NoticeBox } from "./NoticeBox";
import { ClipboardText, ShieldCheck, ListChecks, Images, CalendarBlank, Wrench } from "@phosphor-icons/react";
import { fmtDate } from "../lib/dateUtil";

function Chips({ icon: Icon, title, items, tone, testid }) {
  if (!items?.length) return null;
  return (
    <div className={`border-l-[3px] rounded-r-md px-3 py-2 ${tone}`} data-testid={testid}>
      <p className="text-[10px] uppercase tracking-widest font-semibold mb-1 inline-flex items-center gap-1"><Icon size={11} /> {title}</p>
      <ul className="text-sm space-y-0.5">{items.map((t, i) => <li key={i} className="flex gap-2"><span className="text-muted-foreground">•</span><span>{t}</span></li>)}</ul>
    </div>
  );
}

/* Everything pulled from the source job onto a Works Order (mirrors the PDF): safety notice, schedule, job sheets, compliance docs, checklist, photos. */
export function WoScheduleCells({ wo }) {
  if (!wo.scheduled_start_date && !wo.category) return null;
  const when = wo.scheduled_start_date
    ? `${fmtDate(wo.scheduled_start_date)}${wo.scheduled_end_date && wo.scheduled_end_date !== wo.scheduled_start_date ? ` – ${fmtDate(wo.scheduled_end_date)}` : ""}${[wo.scheduled_start_time, wo.scheduled_end_time].filter(Boolean).length ? `, ${[wo.scheduled_start_time, wo.scheduled_end_time].filter(Boolean).join(" – ")}` : ""}`
    : "";
  return (
    <>
      {when && <div className="border border-border rounded p-2" data-testid="wo-detail-scheduled"><span className="text-muted-foreground inline-flex items-center gap-1"><CalendarBlank size={11} /> Scheduled</span><p className="font-medium">{when}</p></div>}
      {wo.category && wo.category !== "general" && <div className="border border-border rounded p-2" data-testid="wo-detail-trade"><span className="text-muted-foreground inline-flex items-center gap-1"><Wrench size={11} /> Trade</span><p className="font-medium capitalize">{wo.category.replace(/_/g, " ")}</p></div>}
    </>
  );
}

export function WoNotice({ wo }) {
  return <NoticeBox notice={wo.notice} testid="wo-detail-notice" compact />;
}

export function WoJobLists({ wo }) {
  const photos = (wo.job_attachments || []).filter((a) => String(a.type || a.mime_type || "").startsWith("image/"));
  const files = (wo.job_attachments || []).filter((a) => !photos.includes(a));
  return (
    <>
      <Chips icon={ClipboardText} title="Job sheets to complete on site" tone="border-teal-500 bg-teal-50 dark:bg-teal-950/30 text-teal-800 dark:text-teal-200" testid="wo-detail-job-forms"
        items={(wo.job_forms || []).map((f) => f.title)} />
      <Chips icon={ShieldCheck} title="Compliance documents to acknowledge" tone="border-violet-500 bg-violet-50 dark:bg-violet-950/30 text-violet-800 dark:text-violet-200" testid="wo-detail-compliance-docs"
        items={(wo.compliance_docs || []).map((d) => `${d.title}${d.category ? ` — ${d.category.replace(/_/g, " ")}` : ""}`)} />
      <Chips icon={ListChecks} title={`Checklist${wo.checklist_name ? ` — ${wo.checklist_name}` : ""}`} tone="border-slate-400 bg-muted/40 text-foreground" testid="wo-detail-checklist"
        items={(wo.checklist_items || []).map((i) => `${i.text}${i.required ? " (required)" : ""}`)} />
      {(photos.length > 0 || files.length > 0) && (
        <p className="text-[11px] text-muted-foreground inline-flex items-center gap-1" data-testid="wo-detail-attachments">
          <Images size={12} /> {photos.length ? `${photos.length} supporting photo${photos.length === 1 ? "" : "s"}` : ""}{photos.length && files.length ? " and " : ""}{files.length ? `${files.length} file${files.length === 1 ? "" : "s"}` : ""} from the job are included in the PDF.
        </p>
      )}
    </>
  );
}
